/**
 * Central Persian copy dictionary.
 * No component should hardcode user-facing strings — import from here.
 * Organized by feature/area; keep keys flat-ish and descriptive.
 */
export const fa = {
  app: {
    name: 'SMDA',
    tagline: 'آرشیو سلامت خانواده',
  },

  common: {
    loading: 'در حال بارگذاری...',
    retry: 'تلاش دوباره',
    cancel: 'انصراف',
    confirm: 'تأیید',
    save: 'ذخیره',
    edit: 'ویرایش',
    delete: 'حذف',
    back: 'بازگشت',
    next: 'بعدی',
    submit: 'ارسال',
    search: 'جستجو',
    filter: 'فیلتر',
    close: 'بستن',
    add: 'افزودن',
    optional: '(اختیاری)',
    required: '(الزامی)',
    yes: 'بله',
    no: 'خیر',
    somethingWentWrong: 'مشکلی پیش آمد',
    tryAgainLater: 'لطفاً کمی بعد دوباره تلاش کنید.',
    noResults: 'نتیجه‌ای یافت نشد',
    comingSoon: 'به‌زودی',
    unknownInitial: '؟',
    networkError: 'ارتباط با سرور برقرار نشد.',
    unknownError: 'خطای ناشناخته‌ای رخ داد.',
  },

  notFound: {
    title: 'این صفحه پیدا نشد',
    description: 'آدرسی که دنبالش بودید وجود ندارد یا جابه‌جا شده است.',
  },

  theme: {
    label: 'پوسته نمایش',
    light: 'روشن',
    dark: 'تیره',
    system: 'مطابق دستگاه',
    toggleAriaLabel: 'تغییر پوسته نمایش',
  },

  offline: {
    title: 'اتصال اینترنت قطع است',
    description: 'برخی اطلاعات ممکن است به‌روز نباشند؛ با اتصال دوباره، SMDA خودکار همگام می‌شود.',
    backOnline: 'اتصال اینترنت برقرار شد.',
  },

  home: {
    greeting: 'سلام{name}',
    subtitle: 'خلاصه‌ای از آرشیو سلامت خانواده شما',
    quickActionsTitle: 'دسترسی سریع',
    quickAddMember: 'افزودن عضو',
    quickCapture: 'افزودن مدرک',
    quickArchive: 'مرور آرشیو',
    quickReports: 'مشاهده گزارش‌ها',
  },

  nav: {
    home: 'خانه',
    members: 'اعضای خانواده',
    capture: 'افزودن مدرک',
    archive: 'آرشیو',
    profile: 'پروفایل',
    reports: 'گزارش‌ها',
  },

  emptyState: {
    defaultTitle: 'هنوز چیزی اینجا نیست',
    defaultDescription: 'وقتی محتوایی اضافه کنید، همین‌جا نمایش داده می‌شود.',
  },

  errorState: {
    title: 'خطا در بارگذاری اطلاعات',
    description: 'ارتباط با سرور برقرار نشد. اتصال اینترنت خود را بررسی کنید.',
    networkTitle: 'عدم دسترسی به اینترنت',
    networkDescription: 'به نظر می‌رسد اتصال اینترنت قطع است.',
  },

  auth: {
    phoneTitle: 'ورود به SMDA',
    phoneSubtitle: 'شماره موبایل خود را وارد کنید تا کد تأیید برایتان پیامک شود.',
    phoneLabel: 'شماره موبایل',
    phonePlaceholder: '۰۹۱۲۳۴۵۶۷۸۹',
    phoneInvalid: 'شماره موبایل را به‌صورت صحیح وارد کنید.',
    sendOtp: 'ارسال کد تأیید',
    sending: 'در حال ارسال...',
    otpTitle: 'کد تأیید را وارد کنید',
    otpInputAriaLabel: 'کد تأیید',
    otpSubtitle: 'کد ۶ رقمی ارسال‌شده به شماره {phone} را وارد کنید.',
    otpResend: 'ارسال دوباره کد',
    otpResendIn: 'ارسال دوباره تا {seconds} ثانیه دیگر',
    otpVerify: 'تأیید و ورود',
    verifying: 'در حال بررسی...',
    changePhone: 'تغییر شماره',
    otpInvalid: 'کد وارد شده صحیح نیست.',
    otpExpired: 'کد منقضی شده است. کد جدیدی درخواست کنید.',
    otpTooManyAttempts: 'تعداد تلاش‌های شما بیش از حد مجاز است. کمی صبر کنید.',
    rateLimited: 'تعداد درخواست‌های شما زیاد بوده است. لطفاً کمی بعد دوباره تلاش کنید.',
    otpSentToast: 'کد تأیید ارسال شد.',
    otpResentToast: 'کد جدید ارسال شد.',
    loginSuccessToast: 'خوش آمدید!',
    genericError: 'مشکلی در ورود پیش آمد. دوباره تلاش کنید.',
    logout: 'خروج از حساب',
    logoutConfirmTitle: 'خروج از حساب کاربری',
    logoutConfirmDescription: 'برای ورود دوباره باید شماره موبایل خود را تأیید کنید.',
  },

  profile: {
    completeTitle: 'تکمیل پروفایل',
    completeSubtitle: 'برای شروع، چند اطلاعات هویتی خود را تکمیل کنید.',
    fullName: 'نام و نام خانوادگی',
    fullNamePlaceholder: 'برای مثال: علی محمدی',
    fullNameRequired: 'نام و نام خانوادگی را وارد کنید.',
    fullNameTooShort: 'نام باید حداقل ۳ حرف باشد.',
    nationalId: 'کد ملی',
    nationalIdPlaceholder: '۰۰۱۲۳۴۵۶۷۸',
    nationalIdInvalid: 'کد ملی واردشده معتبر نیست.',
    save: 'ذخیره و ورود به SMDA',
    saving: 'در حال ذخیره...',
    saveSuccessToast: 'پروفایل شما تکمیل شد.',
    saveError: 'ذخیره پروفایل با خطا مواجه شد.',
  },

  pwa: {
    installTitle: 'نصب SMDA روی دستگاه',
    installDescription: 'برای دسترسی سریع‌تر، SMDA را به صفحه اصلی اضافه کنید.',
    install: 'نصب برنامه',
    dismiss: 'فعلاً نه',
  },

  category: {
    lab_result: 'آزمایش',
    prescription: 'نسخه',
    imaging: 'تصویربرداری',
    visit_summary: 'خلاصه ویزیت',
    vaccination: 'واکسیناسیون',
    insurance: 'بیمه',
    medical_report: 'گزارش پزشکی',
    other: 'سایر',
  },

  relationship: {
    self: 'خودم',
    spouse: 'همسر',
    child: 'فرزند',
    parent: 'والدین',
    sibling: 'خواهر/برادر',
    other: 'سایر',
  },

  gender: {
    male: 'مرد',
    female: 'زن',
    other: 'سایر',
  },

  members: {
    title: 'اعضای خانواده',
    subtitle: 'مدارک پزشکی هر عضو را جداگانه نگه دارید.',
    addMember: 'افزودن عضو',
    addFirstMember: 'افزودن اولین عضو خانواده',
    emptyTitle: 'هنوز عضوی اضافه نشده',
    emptyDescription: 'با افزودن اعضای خانواده، آرشیو مدارک هرکدام را جداگانه بسازید.',
    documentCount: '{count} مدرک',
    documentCountZero: 'بدون مدرک',
    loadError: 'بارگذاری اعضای خانواده با خطا مواجه شد.',

    // Form
    formAddTitle: 'افزودن عضو خانواده',
    formEditTitle: 'ویرایش اطلاعات عضو',
    formAddDescription: 'اطلاعات این عضو را برای ساخت آرشیو مدارک او وارد کنید.',
    formEditDescription: 'اطلاعات این عضو را به‌روزرسانی کنید.',
    fullName: 'نام و نام خانوادگی',
    fullNamePlaceholder: 'برای مثال: مریم محمدی',
    fullNameRequired: 'نام و نام خانوادگی را وارد کنید.',
    fullNameTooShort: 'نام باید حداقل ۳ حرف باشد.',
    relationshipLabel: 'نسبت با شما',
    relationshipRequired: 'نسبت را انتخاب کنید.',
    relationshipLockedHint: 'نسبت «خودم» قابل تغییر نیست.',
    genderLabel: 'جنسیت',
    genderPlaceholder: 'انتخاب کنید',
    nationalId: 'کد ملی',
    nationalIdPlaceholder: '۰۰۱۲۳۴۵۶۷۸',
    nationalIdInvalid: 'کد ملی واردشده معتبر نیست.',
    phone: 'شماره موبایل',
    phonePlaceholder: '۰۹۱۲۳۴۵۶۷۸۹',
    phoneInvalid: 'شماره موبایل را به‌صورت صحیح وارد کنید.',
    identityRequired: 'وارد کردن کد ملی یا شماره موبایل الزامی است.',
    birthDateLabel: 'تاریخ تولد',
    birthDatePlaceholder: 'انتخاب تاریخ تولد',
    avatarLabel: 'تصویر پروفایل',
    avatarHint: 'اختیاری — بعداً هم می‌توانید اضافه کنید.',
    avatarChoose: 'انتخاب تصویر',
    avatarRemove: 'حذف تصویر',
    save: 'ذخیره',
    saving: 'در حال ذخیره...',
    createSuccessToast: 'عضو جدید اضافه شد.',
    updateSuccessToast: 'اطلاعات عضو به‌روزرسانی شد.',
    saveError: 'ذخیره اطلاعات با خطا مواجه شد.',

    // Detail / delete
    detailNotFound: 'این عضو یافت نشد.',
    detailDocumentsTitle: 'مدارک',
    detailDocumentsComingSoon: 'هنوز مدرکی برای این عضو ثبت نشده است.',
    deleteConfirmTitle: 'حذف عضو خانواده',
    deleteConfirmDescription: 'آیا از حذف «{name}» مطمئن هستید؟ این کار قابل بازگشت نیست.',
    deleteSelfBlocked: 'پروفایل خودتان قابل حذف نیست.',
    deleteSuccessToast: 'عضو موردنظر حذف شد.',
    deleteError: 'حذف عضو با خطا مواجه شد.',
    deleteSelfErrorToast: 'پروفایل خودتان قابل حذف نیست.',
  },

  capture: {
    entryTitle: 'افزودن مدرک جدید',
    entryDescription: 'یک مدرک پزشکی را عکس بگیرید یا از حافظه دستگاه انتخاب کنید.',
    chooseCamera: 'دوربین',
    chooseCameraHint: 'گرفتن عکس فوری از مدرک',
    chooseFile: 'انتخاب از دستگاه',
    chooseFileHint: 'تصویر یا PDF از گالری یا فایل‌ها',

    // Camera sheet
    cameraTitle: 'عکس‌برداری از مدرک',
    cameraPermissionDenied: 'دسترسی به دوربین داده نشد.',
    cameraUnavailable: 'دوربین در دسترس نیست. از انتخاب فایل استفاده کنید.',
    cameraStarting: 'در حال فعال‌سازی دوربین...',
    cameraCapture: 'عکس‌برداری',
    cameraRetake: 'عکس مجدد',
    cameraConfirm: 'تأیید عکس',
    cameraSwitch: 'تغییر دوربین',
    cameraClose: 'بستن دوربین',

    // File picker
    pickerTitle: 'انتخاب فایل',
    pickerDropHint: 'فایل‌ها را اینجا رها کنید',
    pickerOrClick: 'یا برای انتخاب کلیک کنید',
    pickerHelp: 'تصویر (JPG، PNG، HEIC) یا PDF',
    pickerInvalidType: 'این نوع فایل پشتیبانی نمی‌شود.',
    pickerSelected: '{count} فایل انتخاب شد',
    pickerRemove: 'حذف فایل',
    pickerAddMore: 'افزودن فایل بیشتر',

    // Upload form (per-item metadata)
    formTitle: 'جزئیات مدرک',
    formMember: 'مربوط به',
    formMemberPlaceholder: 'عضو خانواده را انتخاب کنید',
    formMemberRequired: 'انتخاب عضو خانواده الزامی است.',
    formDocTitle: 'عنوان',
    formDocTitlePlaceholder: 'برای مثال: آزمایش خون',
    formDocTitleRequired: 'وارد کردن عنوان الزامی است.',
    formCategory: 'دسته‌بندی',
    formDate: 'تاریخ مدرک',
    formDateRequired: 'انتخاب تاریخ الزامی است.',
    formDatePlaceholder: 'انتخاب تاریخ',
    formTags: 'برچسب‌ها',
    formTagsPlaceholder: 'برچسب را تایپ و اینتر بزنید',
    formTagsHint: 'برای افزودن برچسب جدید، تایپ کرده و Enter بزنید.',
    formNotes: 'یادداشت',
    formNotesPlaceholder: 'توضیحات تکمیلی (اختیاری)',
    formProvider: 'پزشک / ارائه‌دهنده',
    formProviderPlaceholder: 'برای مثال: دکتر احمدی',
    formFacility: 'مرکز درمانی',
    formFacilityPlaceholder: 'برای مثال: آزمایشگاه پارس',

    // Queue / upload progress
    queueTitle: 'صف بارگذاری',
    queueUploadAll: 'بارگذاری همه',
    queueUploading: 'در حال بارگذاری...',
    queueStatusPending: 'در انتظار',
    queueStatusUploading: 'در حال ارسال',
    queueStatusSuccess: 'بارگذاری شد',
    queueStatusError: 'ناموفق',
    queueStatusDuplicate: 'مدرک تکراری',
    queueRetry: 'تلاش دوباره',
    queueRemove: 'حذف از صف',
    queueViewExisting: 'مشاهده مدرک موجود',
    queueSkip: 'رد شدن',
    queueAllSuccessTitle: 'همه مدارک بارگذاری شد',
    queueAllSuccessDescription: 'مدارک با موفقیت به آرشیو اضافه شدند.',
    queueDoneClose: 'بستن',
    queueDuplicateMessage: 'این فایل قبلاً برای این عضو بارگذاری شده است.',
    uploadSuccessToast: 'مدرک با موفقیت بارگذاری شد.',
    uploadErrorToast: 'بارگذاری مدرک با خطا مواجه شد.',
  },

  archive: {
    title: 'آرشیو مدارک',
    subtitle: 'مدارک پزشکی خانواده را مرور و جستجو کنید.',
    allDocuments: 'همه مدارک',
    byMember: 'بر اساس عضو خانواده',
    backToFolders: 'بازگشت به اعضا',
    emptyTitle: 'مدرکی یافت نشد',
    emptyDescription: 'با تغییر فیلترها دوباره امتحان کنید یا اولین مدرک را اضافه کنید.',
    emptyAction: 'افزودن مدرک',
    loadError: 'بارگذاری آرشیو با خطا مواجه شد.',

    searchPlaceholder: 'جستجو در عنوان و یادداشت...',
    filters: 'فیلترها',
    filterMember: 'عضو خانواده',
    filterMemberAll: 'همه اعضا',
    filterCategory: 'دسته‌بندی',
    filterCategoryAll: 'همه دسته‌ها',
    filterTag: 'برچسب',
    filterFrom: 'از تاریخ',
    filterTo: 'تا تاریخ',
    filterClear: 'پاک کردن فیلترها',
    filterRemoveOne: 'حذف فیلتر {label}',
    filterApply: 'اعمال فیلتر',
    activeFiltersCount: '{count} فیلتر فعال',

    sortLabel: 'مرتب‌سازی',
    sortDocumentDateDesc: 'جدیدترین تاریخ مدرک',
    sortDocumentDateAsc: 'قدیمی‌ترین تاریخ مدرک',
    sortCreatedAtDesc: 'جدیدترین بارگذاری',
    sortCreatedAtAsc: 'قدیمی‌ترین بارگذاری',
    sortTitleAsc: 'عنوان (الف تا ی)',
    sortTitleDesc: 'عنوان (ی تا الف)',

    loadMore: 'بارگذاری بیشتر',
    resultsCount: '{count} مدرک',
    pdfBadge: 'PDF',
    pagesCount: '{count} صفحه',
  },

  viewer: {
    notFound: 'این مدرک یافت نشد.',
    loadError: 'بارگذاری مدرک با خطا مواجه شد.',
    fileLoadError: 'بارگذاری فایل با خطا مواجه شد.',
    close: 'بستن',
    metadataTitle: 'جزئیات مدرک',
    member: 'عضو خانواده',
    documentDate: 'تاریخ مدرک',
    category: 'دسته‌بندی',
    tags: 'برچسب‌ها',
    notes: 'یادداشت',
    provider: 'پزشک / ارائه‌دهنده',
    facility: 'مرکز درمانی',
    fileInfo: 'مشخصات فایل',
    fileSize: 'حجم فایل',
    fileType: 'نوع فایل',
    uploadedAt: 'تاریخ بارگذاری',
    noNotes: 'یادداشتی ثبت نشده است.',
    noTags: 'برچسبی ثبت نشده است.',

    editTitle: 'ویرایش مدرک',
    editDescription: 'اطلاعات این مدرک را به‌روزرسانی کنید.',
    editSuccessToast: 'مدرک به‌روزرسانی شد.',
    editError: 'ویرایش مدرک با خطا مواجه شد.',

    deleteConfirmTitle: 'حذف مدرک',
    deleteConfirmDescription: 'آیا از حذف «{title}» مطمئن هستید؟ این کار قابل بازگشت نیست.',
    deleteSuccessToast: 'مدرک حذف شد.',
    deleteError: 'حذف مدرک با خطا مواجه شد.',

    pdfPage: 'صفحه {page} از {count}',
    pdfPrevPage: 'صفحه قبل',
    pdfNextPage: 'صفحه بعد',
    pdfLoading: 'در حال بارگذاری PDF...',
    imageLoading: 'در حال بارگذاری تصویر...',
  },

  reports: {
    title: 'گزارش‌ها',
    subtitle: 'نمای کلی از آرشیو سلامت خانواده.',
    loadError: 'بارگذاری گزارش‌ها با خطا مواجه شد.',

    filterMemberLabel: 'عضو خانواده',
    filterMemberAll: 'همه اعضای خانواده',

    // Summary cards
    totalDocuments: 'کل مدارک',
    totalMembers: 'اعضای خانواده',
    storageUsed: 'حجم ذخیره‌شده',
    topCategory: 'پرتکرارترین دسته',
    topCategoryEmpty: '—',
    recentActivityTitle: 'فعالیت‌های اخیر',
    recentActivityEmpty: 'هنوز مدرکی ثبت نشده است.',
    summaryLoadError: 'بارگذاری خلاصه گزارش با خطا مواجه شد.',
    summaryEmptyTitle: 'هنوز گزارشی وجود ندارد',
    summaryEmptyDescription: 'با افزودن اولین مدرک، گزارش‌های خانواده اینجا شکل می‌گیرد.',

    // Timeline
    timelineTitle: 'مدارک در طول زمان',
    timelineSubtitle: 'داستان سلامت خانواده، ماه به ماه',
    timelineLoadError: 'بارگذاری جدول زمانی با خطا مواجه شد.',
    timelineEmptyTitle: 'هنوز داده‌ای برای نمایش نیست',
    timelineEmptyDescription: 'با افزودن مدارک بیشتر، روند زمانی آن‌ها را اینجا ببینید.',
    timelineDocumentsCount: '{count} مدرک',

    // Category chart
    categoryChartTitle: 'مدارک بر اساس دسته‌بندی',
    categoryChartSubtitle: 'سهم هر دسته از کل آرشیو',
    categoryChartLoadError: 'بارگذاری نمودار دسته‌بندی با خطا مواجه شد.',
    categoryChartEmptyTitle: 'دسته‌بندی‌ای برای نمایش نیست',
    categoryChartEmptyDescription: 'با دسته‌بندی مدارک، این نمودار تکمیل می‌شود.',
    categoryChartCount: '{count} مدرک',
    categoryChartSize: 'حجم: {size}',

    // Member breakdown
    memberBreakdownTitle: 'مدارک بر اساس عضو خانواده',
    memberBreakdownSubtitle: 'مقایسه آرشیو هر عضو خانواده',
    memberBreakdownLoadError: 'بارگذاری گزارش اعضا با خطا مواجه شد.',
    memberBreakdownEmptyTitle: 'عضوی برای نمایش نیست',
    memberBreakdownEmptyDescription: 'با افزودن عضو خانواده و مدارک او، این بخش تکمیل می‌شود.',
    memberBreakdownDocumentsCount: '{count} مدرک',
    memberBreakdownNoDocuments: 'بدون مدرک',
  },
} as const;

export type FaDictionary = typeof fa;
